<template>
    <v-dialog v-model="$store.state.analytics.truckCost" max-width="700px">
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">
                    Truck Actual Profit By
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container class="px-10">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Truck</th>
                            <th>Maintenance</th>
                            <th>Fuel Cost Consup.</th>
                            <th>Truck Cost</th>
                        </tr>
                    </thead>
                    <tbody v-for="itm in TruckInfo" v-bind:key="itm.TruckID">
                        <tr>
                            <td>{{ itm.Truck }}</td>
                            <td>{{ itm.Maintenance }}</td>
                            <td>{{ itm.FuelCons }}</td>
                            <td>{{ itm.TruckCost }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['data'],
    data: function() {
        return {
            TruckInfo:[],
        };
    },
    
    mounted() {
        this.getActualCost();
    },
    methods: {
        getActualCost: function() {
            var parms = {
                StartDate: this.$store.state.analytics.StartTime,
                EndDate: this.$store.state.analytics.EndTime,
                Truck: this.$store.state.analytics.itm.TruckID,
            };
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('shift-analytics/actual-cost/profit',parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.TruckInfo = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>
